import { useCallback, useState } from 'react';
import type { Segment } from '../../types';

export const useSegmentHover = () => {
  const [hoveredSegmentKey, setHoveredSegmentKey] = useState<
    Segment['position'] | null
  >(null);

  const onSegmentHover = useCallback(
    (segmentKey: Segment['position'] | null) => {
      setHoveredSegmentKey(segmentKey);
    },
    [setHoveredSegmentKey],
  );

  const getIsSegmentHovered = useCallback(
    (segmentKey: Segment['position']) => {
      return segmentKey === hoveredSegmentKey;
    },
    [hoveredSegmentKey],
  );

  return {
    onSegmentHover,
    getIsSegmentHovered,
    isAnySegmentHovered: hoveredSegmentKey !== null,
  };
};
